// extracted by mini-css-extract-plugin
export default {"formHeading":"FH-z","form":"GH-z","submitBtn":"HH-z","disabled":"IH-z","input":"JH-z","error":"KH-z","submitMsg":"LH-z","signIn":"MH-z"};